import { Component, Input, OnDestroy, OnInit } from '@angular/core';

@Component({
  selector: 'app-loader-inline',
  templateUrl: './loader-inline.component.html',
  styleUrls: ['./loader-inline.component.scss']
})
export class LoaderInlineComponent implements OnInit, OnDestroy {

  @Input() messages: string[] | null = []; // Færibreytan fyrir skilaboð
  @Input() showProgressBar: boolean = false; // Færibreytan fyrir skilaboð

  progress = 0;
  loadingMessage = '';
  private intervalId!: any;
  private dotsIntervalId!: any; // Interval fyrir punktana
  private elapsedTime = 0; // Tími í sekúndum
  public dots = ''; // Fyrir punktana

  ngOnInit() {
    if (this.messages?.length > 0) {
      this.startProgress();
      this.startDotsAnimation(); // Byrja punktana
    }
  }

  startProgress() {
    this.intervalId = setInterval(() => {
      this.elapsedTime += 0.1; // Uppfæra á 0.1 sekúndu fresti

      if (this.elapsedTime <= 4) {
        // Fyrstu 50% á 4 sekúndum
        this.progress = Math.ceil(Math.min(50, (this.elapsedTime / 4) * 50));
      } else if (this.elapsedTime <= 8) {
        // Næstu 25% á 4 sekúndum
        this.progress = Math.ceil(50 + ((this.elapsedTime - 4) / 4) * 25);
      } else if (this.elapsedTime <= 18) {
        // Næstu 10% á 10 sekúndum
        this.progress = Math.ceil(75 + ((this.elapsedTime - 8) / 10) * 10);
      } else if (this.elapsedTime <= 78) {
        // Síðustu 5% á 60 sekúndum
        this.progress = Math.ceil(85 + ((this.elapsedTime - 18) / 60) * 14);
      } else {
        // Festist í 99%
        this.progress = 99;
        clearInterval(this.intervalId);
      }

      // Breyta skilaboðum eftir framvindu
      if (this.progress < 22 && this.messages[0]) {
        this.loadingMessage = this.messages[0];
      } else if (this.progress < 40 && this.messages[1]) {
        this.loadingMessage = this.messages[1];
      } else if (this.progress < 65 && this.messages[2]) {
        this.loadingMessage = this.messages[2];
      } else if (this.progress < 85 && this.messages[3]) {
        this.loadingMessage = this.messages[3];
      } else if (this.progress === 99 && this.messages[4]) {
        this.loadingMessage = this.messages[4];
      }
    }, 100); // 100ms = 0.1 sekúndur
  }

  startDotsAnimation() {
    let dotCount = 0;
    this.dotsIntervalId = setInterval(() => {
      dotCount = (dotCount + 1) % 4; // Telur frá 0 upp í 3
      this.dots = '.'.repeat(dotCount); // Fjöldi punkta
    }, 1000); // Uppfærir á 1 sekúndu fresti
  }

  ngOnDestroy() {
    clearInterval(this.intervalId);
    clearInterval(this.dotsIntervalId);
  }
}
